// extracted by mini-css-extract-plugin
export var actionButton = "_k8-t";
export var buttonContainer = "_k8-0";
export var buttonContainer2 = "_k8-1";
export var buttonSection = "_k8-2";
export var details = "_k8-3";
export var dropdownItem = "_k8-5";
export var dropdownItemsContainer = "_k8-4";
export var fileInput = "_k8-r";
export var headerButton = "_k8-6";
export var icon = "_k8-7";
export var input = "_k8-8";
export var macroListItem = "_k8-9";
export var mainContent = "_k8-a";
export var microText = "_k8-b";
export var modal = "_k8-w";
export var optionsButton = "_k8-c";
export var paperclip = "_k8-s";
export var pillContent = "_k8-d";
export var preview = "_k8-e";
export var preview2 = "_k8-f";
export var quillEditor = "_k8-q";
export var selectedMacro = "_k8-g";
export var sidebar = "_k8-h";
export var sidebarHeader = "_k8-j";
export var sidebarList = "_k8-i";
export var sidebarListItem = "_k8-k";
export var sidebarSearch = "_k8-l";
export var snoozeDurationWrapper = "_k8-v";
export var statusPillContainer = "_k8-m";
export var tagsContainer = "_k8-n";
export var unselectedMacro = "_k8-o";
export var variable = "_k8-u";
export var wrapper = "_k8-p";